import { render, staticRenderFns } from "./contract_draft_service_ru.vue?vue&type=template&id=563e4fcc&"
import script from "./contract_draft_service_ru.vue?vue&type=script&lang=js&"
export * from "./contract_draft_service_ru.vue?vue&type=script&lang=js&"
import style0 from "./contract_draft_service_ru.vue?vue&type=style&index=0&id=563e4fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports